import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

// Kill switch for the Eruda overlay across every environment. Set true
// while we're taking clean screenshots for the beta welcome pack;
// flipping back to false (or deleting this constant and its early-return
// below) restores the per-email allowlist behaviour without further code
// changes.
const ERUDA_DISABLED = true;

// Emails permitted to see the Eruda mobile-style dev console overlay.
// Edit this list to add or remove dev console viewers.
const DEV_CONSOLE_EMAILS = new Set<string>([
  'jrichards3@uel.ac.uk',
  'jr3456@uel.ac.uk',
]);

let erudaInitialised = false;

// Loads the Eruda console overlay (https://github.com/liriliri/eruda) only for
// allowlisted UEL staff emails. Mount once near the root inside AuthProvider.
export default function DevConsoleLoader() {
  const { user } = useAuth();

  useEffect(() => {
    if (ERUDA_DISABLED) return;
    if (erudaInitialised) return;
    if (!user?.email) return;
    if (!DEV_CONSOLE_EMAILS.has(user.email.toLowerCase())) return;

    let cancelled = false;
    void import('eruda').then((eruda) => {
      if (cancelled || erudaInitialised) return;
      eruda.default.init();
      erudaInitialised = true;
    });

    return () => {
      cancelled = true;
    };
  }, [user?.email]);

  return null;
}
